import { Box } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { ICreateFairStall } from "src/Utils/type";
import StallForm from "./StallForm";

interface Props {
	handleClose: () => void;
}

const CreateFairStall = ({ handleClose }: Props) => {
	const { register, handleSubmit, setValue, reset } =
		useForm<ICreateFairStall>({});

	const {
		mutate: createStall,
		isPending,
		isSuccess,
	} = useApiMutation<Record<string, string | number>, void>({
		method: "POST",
		endPoint: "/api/fair/stall",
		invalidateQueries: ["FairStalls"],
	});

	const onSubmit = (value: ICreateFairStall) => {
		createStall({
			...value,
			fair_stall_air_conditioned: value.fair_stall_air_conditioned
				? 1
				: 0,
		});
	};

	useEffect(() => {
		if (isSuccess) {
			reset();
			handleClose();
		}
	}, [isSuccess]);
	return (
		<Box component='form' onSubmit={handleSubmit(onSubmit)}>
			<StallForm
				isPending={isPending}
				buttonText='Create Stall'
				register={register}
			/>{" "}
		</Box>
	);
};

export default CreateFairStall;
